import type { ContextType, ReactNode } from "react";
import { InstantSearch, type InstantSearchProps } from "react-instantsearch";
import { SearchTransportContext } from "@/hooks/use-searchkit-client";

export interface SearchRootProps {
  children: ReactNode;
  initialUiState?: InstantSearchProps["initialUiState"];
  onStateChange?: InstantSearchProps["onStateChange"];
  /** Return value of a `use*Search` hook (the `useSearchkitClient` shape). */
  search: {
    indexName: string;
    searchClient: InstantSearchProps["searchClient"];
    searchTransport: ContextType<typeof SearchTransportContext>;
  };
}

/** The InstantSearch mount for a search page. Keeps the two things that must
 *  never drift apart together: `preserveSharedStateOnUnmount` (widgets like the
 *  always-mounted Configure rely on it) and the transport context that surfaces
 *  the errors InstantSearch swallows. */
export function SearchRoot({ children, initialUiState, onStateChange, search }: SearchRootProps) {
  return (
    <InstantSearch
      future={{ preserveSharedStateOnUnmount: true }}
      indexName={search.indexName}
      initialUiState={initialUiState}
      onStateChange={onStateChange}
      searchClient={search.searchClient}
    >
      <SearchTransportContext.Provider value={search.searchTransport}>{children}</SearchTransportContext.Provider>
    </InstantSearch>
  );
}
